import DemoWrapper from "../../utils/DemoPageWrapper";
/* eslint-disable import/no-webpack-loader-syntax */
import Demo from "./demo";
import DemoSource from "!!raw-loader!./demo.vue";

const config = {
  props: [
    {
      prop: "value",
      description: "当前页码",
      type: "Number",
      required: "true",
      available: "正整数"
    },
    {
      prop: "theme",
      description: "主题 num/fill/border",
      type: "String",
      default: "num"
    },
    {
      prop: "size",
      description: "大小 mini/small/default/middle/large",
      type: "String",
      default: "default"
    },
    {
      prop: "total",
      description: "总条目数",
      type: "Number"
    },
    {
      prop: "pageSize",
      description: "每页显示数量",
      type: "Number",
      default: "10"
    },
    {
      prop: "pageSizes",
      description: "每页显示条目可选值",
      type: "Array",
      default: "[10, 20, 50]"
    },
    {
      prop: "pagerCount",
      description: "页码按钮的数量，当总页数超过该值时会折叠",
      type: "Number",
      default: 7,
      available: "大于等于3的正奇数"
    },
    {
      prop: "multi",
      description: "是否显示完整信息",
      type: "Boolean",
      default: "false"
    },
    {
      prop: "showGoto",
      description: "显示完整信息时是否显示直接跳转器",
      type: "Boolean",
      default: "true"
    }
  ],
  events: [
    {
      name: "change",
      description: "页码改变事件",
      argument: "value 页码"
    },
    {
      name: "sizeChange",
      description: "pageSize改变事件",
      argument: "pageSize"
    }
  ],
  methods: [],
  slots: []
};

export default DemoWrapper(Demo, DemoSource, config);
